import "./Passion.scss";
import PassionCard from "../PassionCard/PassionCard";
import { useTranslation } from "react-i18next";

const Passion = () => {
  const {t} = useTranslation();
  const passionData = t("passionData", {returnObjects: true})
  return (
    <section id="passion" className="passion">
      <h2 className="passion__title">
        {t("passionTitle.title1")}
        <span className="passion__title--special">
          {t("passionTitle.title2")}
        </span>
      </h2>
      <div className="passion__container">
        {passionData.map((card, idx) => (
          <PassionCard
            key={idx}
            image={card.image}
            title={card.title}
            content={card.content}
          />
        ))}
      </div>
    </section>
  );
};

export default Passion;
